module.exports = __webpack_public_path__ + "img/box_9.efa3d8e0.jpg";